export default __webpack_public_path__ + "static/media/video3.98b06290.mp4";